import { render } from "./CustomerDataSharingApproval.vue?vue&type=template&id=561ed479"
import script from "./CustomerDataSharingApproval.vue?vue&type=script&lang=js"
export * from "./CustomerDataSharingApproval.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__